var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from "react-redux";
var NaverTalk = function (_a) {
    var children = _a.children, idx_b_manager = _a.idx_b_manager, b_member = _a.b_member, itemId = _a.itemId, isStdpc = _a.isStdpc;
    /**
     * 네이버 톡톡으로 전달할 상품의 수량 구하기
     * 일반상품, 조립 PC 상품 일때 각각의 수량을 구해야 합니다.
     */
    var stdpcSelect = useSelector(function (state) { return state.product.stdpcSelect; });
    var productSelect = useSelector(function (state) { return state.product.productSelect; });
    var count = isStdpc ? stdpcSelect.each : productSelect.each;
    var url = "".concat(process.env.REACT_APP_API_URL, "/front/v2/talkTalk/shopLink/");
    var productTalk = function () {
        /**
         *  _url 예시 : https://api.pping.{env}/front/v2/talkTalk/shopLink/8660?ref_type=detail&item=11080062|2
         *  _url을 통해 백엔드로 전달할 정보
         *  idx_b_manager : 8660
         *  ref_type : detail
         *  item : 상품번호|수량 형태로 전달해야합니다.
         *  참고 : b_member 정보는 _url로 전달되지 않고 쿠키정보로 넘어갑니다.
         */
        var _url = "".concat(url).concat(idx_b_manager, "?ref_type=detail&item=").concat(itemId, "|").concat(count);
        /**
         * 비로그인 상태일 경우 SSO 페이지로 이동합니다
         */
        if (b_member === undefined || b_member === '') {
            window.location.href = process.env.REACT_APP_SSO_URL;
            return false;
        }
        /**
         * 새창을 열고 _url로 이동합니다.
         * 백엔드측에서 _url정보를 통해 네이버 톡톡으로 이동합니다.
         */
        window.open(_url, 'naverTalk' + idx_b_manager, 'scrollbars=no,resizable=no,width=500,height=500');
    };
    return (React.createElement(Style, { onClick: productTalk }, children));
};
var Style = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
export default NaverTalk;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/naver_talk/index.tsx
// module id = 208
// module chunks = 0